import { render, staticRenderFns } from "./NotificationTypeDetail.vue?vue&type=template&id=36d60316&scoped=true&"
import script from "./NotificationTypeDetail.vue?vue&type=script&lang=js&"
export * from "./NotificationTypeDetail.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTypeDetail.vue?vue&type=style&index=0&id=36d60316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d60316",
  null
  
)

export default component.exports